import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Button from '../Button';
import './DefaultButton.scss';

const DefaultButton = ({ className, onClick, locKey, hidden = false, disabled = false, secondary = false, ...props }) => (
  <Button
    className={classnames('qau-default-button', className, { hidden, disabled, secondary })}
    onClick={onClick}
    locKey={locKey}
    {...props}
  />
);

DefaultButton.propTypes = {
  className: PropTypes.string,
  locKey: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  hidden: PropTypes.bool,
  disabled: PropTypes.bool,
  secondary: PropTypes.bool,
};

export default DefaultButton;
